<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
  <c-modal-header>
      <h4 class="modal-title">{{ "User Signup" }}</h4>
      <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal(false)" title="Close"></button>
  </c-modal-header>
  <c-modal-body>
    <c-row>
      <form cForm class="animate" (ngSubmit)="createUser()" [formGroup]="userSignupForm">
        <!-- Branch -->
        <c-row>
          <c-col [md]="3">
            <label cLabel for="branch">{{ "Branch" }}</label>
          </c-col>
          <c-col [md]="8">
            <select cFormControl formControlName="branch" aria-label="Please select a branch" cSelect>
              <option *ngFor="let branch of branchesList" [ngValue]="branch">{{branch.name}}</option>
            </select>
          </c-col>
        </c-row>

        <!-- Username -->
        <c-row>
          <c-col [md]="3">
            <label cLabel for="username">{{ "Username" }}</label>
          </c-col>
          <c-col [md]="8">
            <input cFormControl formControlName="username" name="username" type="text" class="form-control" id="username" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userSignupForm.controls['username'].valid && !userSignupForm.controls['username'].untouched">
              {{ "Username is required" }}
            </div>
          </c-col>
        </c-row>

        <!-- First Name -->
        <c-row>
          <c-col [md]="3">
            <label cLabel for="firstName">{{ "First Name"}}</label>
          </c-col>
          <c-col [md]="8">
            <input cFormControl formControlName="firstName" name="firstName" type="text" class="form-control" id="firstName" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userSignupForm.controls['firstName'].valid && !userSignupForm.controls['firstName'].untouched">
              {{ "First name is required" }}
            </div>
          </c-col>
        </c-row>

        <!-- Last Name -->
        <c-row>
          <c-col [md]="3">
            <label cLabel for="lastName">{{ "Last Name" }}</label>
          </c-col>
          <c-col [md]="8">
            <input cFormControl formControlName="lastName" name="lastName" type="text" class="form-control" id="lastName" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated" *ngIf="!userSignupForm.controls['lastName'].valid && !userSignupForm.controls['lastName'].untouched">
              {{ "Last name is required" }}
            </div>
          </c-col>
        </c-row>

        <!-- Email -->
        <c-row>
          <c-col [md]='3'>
            <label cLabel for="email">{{ "Email" }}</label>
          </c-col>
          <c-col [md]='8'>
            <input cFormControl formControlName="email" name="email" type="email" class="form-control" id="email" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated"
              *ngIf="userSignupForm.controls['email'].hasError('required') && !userSignupForm.controls['email'].untouched">
                {{ "Email is required." }}
            </div>
          </c-col>
        </c-row>

        <!-- Password -->
        <c-row>
          <c-col [md]='3'>
            <label cLabel for="password">{{ "Password" }}</label>
          </c-col>
          <c-col [md]='8'>
            <input cFormControl formControlName="password" name="password" type="password" class="form-control" id="password" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated"
              *ngIf="userSignupForm.controls['password'].hasError('required') && !userSignupForm.controls['password'].untouched">
                {{ "Password is required." }}
            </div>
          </c-col>
        </c-row>

        <!-- Confirm Password -->
        <c-row>
          <c-col [md]='3'>
            <label cLabel for="confirmPassword">{{ "Confirm Password" }}</label>
          </c-col>
          <c-col [md]='8'>
            <input cFormControl formControlName="confirmPassword" name="confirmPassword" type="password" class="form-control" id="confirmPassword" />
            <div class="alert alert-danger my-1 p-2 fadeInDown animated"
              *ngIf="userSignupForm.controls['confirmPassword'].hasError('required') && !userSignupForm.controls['confirmPassword'].untouched">
                {{ "Confirm password is required." }}
            </div>
          </c-col>
        </c-row>

        <c-row>
            <c-col [md]='3'></c-col>
            <c-col [md]='8'>
              <button type="submit" [disabled]="!userSignupForm.valid" class="btn btn-primary primary w-100">
                  <i class="fa fa-circle-o-notch fa-spin" [hidden]="!isSigningUpUser"></i>
                  <c-spinner [hidden]="!isSigningUpUser"></c-spinner>{{ "Submit" }}
              </button>
            </c-col>
        </c-row>
      </form>
    </c-row>
  </c-modal-body>
</c-modal>
